// extracted by mini-css-extract-plugin
export default {"container":"Suggestions_container__Qo4TH","chip_avatar":"Suggestions_chip_avatar__3YHhQ"};